import herobackground from "../assets/images/herobackground.jpg";

export default function Herosection() {
  return (
    <section id="hjem" className="relative h-screen w-full overflow-hidden">
      <img
        src={herobackground}
        alt="Krokeide"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40" />
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-4">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">Visit Krokeide</h1>
        <p className="text-lg md:text-xl max-w-2xl">
          Vi er en ungdomsbedrift som skreddersyr arrangementer til ulike
          målgrupper. Vår bedrift spiller på de fine omgivelsene på Krokeide og
          drifter to salgsarenaer.
        </p>
        <div className="mt-6 flex gap-4">
          <a href="#om-oss">
            <button className="bg-[#FD517B] text-white px-8 py-1 rounded-md hover:bg-pink-600 transition">
              Les mer
            </button>
          </a>
          <a href="#kontakt">
            <button className="border border-white hover:bg-white hover:text-gray-800 text-white px-8 py-1 rounded-md text-sm">
              Kontakt
            </button>
          </a>
        </div>
      </div>
    </section>
  );
}
